import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEventType } from '../../constants';
import { CookieBannerActionType } from '~shared/modules/application-event/constants';

export class GATrackingCookieBannerEvent implements GATrackingEvent {
  constructor(private payload: any) {}

  getEventType(): any {
    if (this.payload.action === CookieBannerActionType.CookieBannerShown) {
      return CookieBannerActionType.CookieBannerShown;
    } else {
      return CookieBannerActionType.CookieConsent;
    }
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GATrackingEventType.CookieConsent,
      label: this.payload.state
    };
  }
}
